module.exports = __webpack_public_path__ + "img/7.c9a0182.jpg";